import axios from 'axios'
// import { UrlBase } from './config'
const UrlBase = 'http://aa7b38cc.ngrok.io/'

const speech = {}
const speechData = {
  audioInsights: undefined
}

speech.getProjects = (companyId, appId) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        // 'Authorization': 'Bearer ' + token
      },
      url: `${UrlBase}company/${companyId}/app/${appId}/project`
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(() => { // error => {
        // let message = error.response
        // if (!message) return reject(new Error(error.message))
        // else return reject(new Error(message.data.error))
        if (speechData.audioInsights === undefined) {
          // let request = {
          //   method: 'GET',
          //   headers: {
          //     'Access-Control-Allow-Origin': '*',
          //     'Origin': 'http://localhost:8080',
          //     'Access-Control-Allow-Methods': 'GET',
          //     'Access-Control-Request-Headers': 'Content-Type'
          //   },
          //   url: `https://storage.googleapis.com/keybe/apptest/speechData.js`
          // }
          // axios(request)
          //   .then(response => {
          //     // resolve(response.data)
          //     console.log('response')
          //     console.log(response)
          //     speechData.audioInsights = response
          //   })
          //   .catch(() => { // error => {
          //   })
          const head = document.getElementsByTagName('head')[0]
          const script = document.createElement('script')
          script.type = 'text/javascript'
          // https://javascript-minifier.com/raw
          // https://jscompress.com/ --> Better
          script.src = 'https://storage.googleapis.com/keybe/apptest/speechData.min.js'
          head.appendChild(script)
          speechData.audioInsights = true
        }
        const speechProjects = []
        let count = 0
        // if appid is keybe or is stefanini
        if (appId === 'bisovsddqjmtl2w5k' || appId === '23ba9i4jy9hrvmd') {
          speechProjects.push(
            {
              id: '1',
              name: 'Mesa de ayuda Claro',
              description: 'Medición de niveles de atención a los colaboradores y contratistas de Claro',
              createdAt: '2019-06-24T00:00:00.000Z'
            }
          )
          count++
        }
        // if appid is keybe or is uno27
        if (appId === 'bisovsddqjmtl2w5k' || appId === '23ba9i4jy9i67nk') {
          speechProjects.push(
            {
              id: '2',
              name: 'Auditoria de Televentas uno27',
              description: '',
              createdAt: '2019-07-18T22:00:00.000Z'
            }
          )
          count++
        }
        // if appid is keybe or is POC Cos
        if (appId === 'bisovsddqjmtl2w5k' || appId === '23bacdmjyelxtj4') {
          speechProjects.push(
            {
              id: '3',
              name: 'POC Cos',
              description: 'Identificación de indicadores para evaluar las dinamicas de la llamada y el desempeño del agente',
              createdAt: '2019-07-22T22:00:00.000Z'
            }
          )
          count++
        }
        // if appid is keybe or is pintuco speech
        if (appId === 'bisovsddqjmtl2w5k' || appId === '23bac2sjz3aqryu') {
          speechProjects.push(
            {
              id: '4',
              name: 'SAC',
              description: 'agente',
              createdAt: '2019-08-07T22:00:00.000Z'
            }
          )
          count++
        }
        // if appid is keybe or is Invamer
        if (appId === 'bisovsddqjmtl2w5k' || appId === '23bam8zk0g5ekde') {
          speechProjects.push(
            {
              id: '5',
              name: 'Percepción Sura y Protección',
              description: '',
              createdAt: '2019-09-07T22:00:00.000Z'
            }
          )
          count++
        }
        // if appid is keybe or is Flamingo
        if (appId === 'bisovsddqjmtl2w5k' || appId === '23bam3yk0opt6jq') {
          speechProjects.push(
            {
              id: '6',
              name: 'Mesa de cobranzas Flamingo',
              description: 'Calidad del servicio brindado',
              createdAt: '2019-09-17T22:00:00.000Z'
            }
          )
          count++
        }
        // if appid is keybe or is Sura
        if (appId === 'bisovsddqjmtl2w5k' || appId === '23babiqk1m61j92') {
          speechProjects.push(
            {
              id: '7',
              name: 'Mesa de vida Sura',
              description: 'Evaluaciones de las conversaciones entre el agente y los usuarios que llaman a la mesa de ayuda.',
              createdAt: '2019-10-09T22:00:00.000Z'
            }
          )
          count++
        }
        resolve({ rows: speechProjects, count })
      })
  })
}

speech.createProject = (companyId, appId, { name, description }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'POST',
      headers: {
        // 'Authorization': 'Bearer ' + token
      },
      url: UrlBase + 'project/',
      data: { name, description, company: companyId, app: appId }
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

speech.updateProject = (companyId, appId, { id, name, description }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'PUT',
      headers: {
        // 'Authorization': 'Bearer ' + token
      },
      url: UrlBase + 'project/',
      data: { id, name, description, company: companyId, app: appId }
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

speech.getProjectInsights = (companyId, appId, { id }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      /*
      headers: {
        'Authorization': 'Bearer ' + token
      },
      */
      url: `${UrlBase}company/${companyId}/app/${appId}/project/${id}/insights`
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(() => { // error => {
        // let message = error.response
        // if (!message) return reject(new Error(error.message))
        // else return reject(new Error(message.data.error))
        let insights = {}
        if (id === '1') {
          insights = {
            // Counters:
            totalProcessedAudios: 100,
            totalProcessedSeconds: 61238,
            averageTimePerCall: 612,
            percentageSilents: 0.459,
            averageConversations: 331,
            receivedConversations: 100,
            speakTimeMinutes: 1021,
            averageTimeGeneralCall: { // TODO what the fuck is this and why doesn't it update the front end
              ue: 903,
              uq: 487,
              median: 259,
              lq: 178,
              le: 40
            },
            // TODO below here - ??? I dont have this data
            sellAndOffer: {
              conversations: 3501,
              portion: {
                count: {
                  calls: 9013,
                  offerings: 3254,
                  sell: 925
                },
                percentage: {
                  calls: 0.66,
                  offerings: 0.34,
                  sell: 0.1
                }
              },
              buyDeterminant: ['Número de guía', 'Política']
            },
            averageSellCall: {
              effective: {
                ue: 903,
                uq: 487,
                median: 259,
                lq: 178,
                le: 40
              },
              general: {
                ue: 600,
                uq: 325,
                median: 250,
                lq: 100,
                le: 0
              },
              additionalTime: 1.4
            },
            unconformity: {
              total: 9013,
              portion: {
                total: 92,
                reason: [
                  { name: 'Mal Servicio', count: 4 },
                  { name: 'Muy caro', count: 5 },
                  { name: 'Son malos', count: 4 },
                  { name: 'No tienen Producto', count: 71 }
                ]
              }
            },
            rivalry: {
              total: 9013,
              count: 256,
              rows: [
                { name: 'Competencia 1', count: 19 },
                { name: 'Competencia 2', count: 15 },
                { name: 'Competencia 3', count: 9 },
                { name: 'Competencia 4', count: 5 },
                { name: 'Competencia 5', count: 3 }
              ]
            },
            averageCallTime: true,
            pickupTime: true,
            successStartConversation: true,
            requestForWaitTime: true,
            waitTimes: true,
            justifiedWaitTime: true,
            giveServiceTime: true,
            inappropiateWords: true,
            allowedCloseCall: true,
            serviceSurvey: true
          }
        }
        if (id === '2') {
          insights = {
            // Counters:
            totalProcessedAudios: 4,
            totalProcessedSeconds: 1239,
            averageTimePerCall: 309,
            percentageSilents: 0.024,
            averageConversations: 235
          }
        }
        if (id === '3') {
          insights = {
            // Counters:
            totalProcessedAudios: 10,
            totalProcessedSeconds: 4574,
            averageTimePerCall: 457,
            percentageSilents: 0.19,
            averageConversations: 538,
            averagePickupTime: 65
          }
        }
        if (id === '4') {
          insights = {
            // Counters:
            totalProcessedAudios: 92,
            totalProcessedSeconds: 25405,
            averageTimePerCall: 276,
            percentageSilents: 0.51,
            averageConversations: 134,
            averagePickupTime: 1.72
          }
        }
        if (id === '5') {
          insights = {
            // Counters:
            totalProcessedAudios: 93,
            totalProcessedSeconds: 66026,
            averageTimePerCall: 1196,
            percentageSilents: 0.28,
            averageConversations: 858,
            averagePickupTime: 1.9
          }
        }
        if (id === '6') {
          insights = {
            // Counters:
            totalProcessedAudios: 100,
            totalProcessedSeconds: 28475,
            averageTimePerCall: 284,
            percentageSilents: 0.17,
            averageConversations: 222,
            averagePickupTime: 5.7,
            promiseCalls: 35,
            negotiationCalls: 22,
            reluctantCalls: 35
          }
        }
        if (id === '7') {
          insights = {
            // Counters:
            totalProcessedAudios: 102,
            totalProcessedSeconds: 74068,
            averageTimePerCall: 726,
            percentageSilents: 0.3,
            averageConversations: 726,
            averagePickupTime: 32
          }
        }
        resolve({ insights })
      })
  })
}

speech.getProjectAudios = (companyId, appId, { id }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      /*
      headers: {
      'Authorization': 'Bearer ' + token
      },
      */
      url: `${UrlBase}company/${companyId}/app/${appId}/project/${id}/audios`
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(async () => {
        const audiosTranscript = speechData.audioInsights ? await window.speechData.audioInsights(id) : {}
        resolve({ audiosTranscript })
      })
  })
}

speech.uploadAudioPost = (projectId, { filesForm }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'POST',
      headers: {
        // 'Authorization': 'Bearer ' + token
        'Content-Type': 'multipart/form-data'
      },
      url: `${UrlBase}project/${projectId}/audio/upload`,
      data: filesForm
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

speech.getAudioInsights = ({ fileName }, index) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      /*
      headers: {
        'Authorization': 'Bearer ' + token
      },
      */
      url: `${UrlBase}audio/insights`,
      params: {
        file: fileName
      }
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(() => { // error => {
        // let message = error.response
        // if (!message) return reject(new Error(error.message))
        // else return reject(new Error(message.data.error))
        resolve({
          conversation: {
            time: {
              silent: 60,
              speaking: 123
            },
            percentage: {
              silent: 0.33,
              speaking: 0.67
            },
            script: [
              { character: 'Agente', text: 'Buen día mi nombre es Martin Samana con quien tengo el gusto de hablar' },
              { character: 'Cliente', text: 'Buenos dias con Marcela ' },
              { character: 'Agente', text: 'Mucho gusto, cuéntame en que te puedo colaborar' },
              { character: 'Cliente', text: 'Hazme un favor lo que pasa es que yo debo de tener ya las claves por recontratación pero no me estan funcionando, me podrías verificar por favor ' },
              { character: 'Agente', text: 'Osea no te esta funcionando ninguna clave' },
              { character: 'Cliente', text: 'pues es que me dijeron que podía entrar con las mismas que tenia antes pero no me estan sirviendo' },
              { character: 'Agente', text: 'y a donde estas ingresando de primeras ' },
              { character: 'Cliente', text: 'eh por citry' },
              { character: 'Agente', text: 'Listo, cual es tu usuario de red' },
              { character: 'Cliente', text: 'es sm1374b' },
              { character: 'Agente', text: 'b larga?' },
              { character: 'Cliente', text: 'si' },
              { character: 'Agente', text: 'okey permítame un segundo el linea yo veo si paso algo ya vuelvo contigo' },
              { character: 'Agente', text: 'gracias por esperar' },
              { character: 'Cliente', text: 'si senor' },
              { character: 'Agente', text: 'ven el usuario que tu me indicaste tiene todo desactivado, desactivado y revocado' },
              { character: 'Cliente', text: 'osea no hay nada de recontratación, no hay nada?' },
              { character: 'Agente', text: 'listo espera veamos con tu cedula, me la confirmas por favor' },
              { character: 'Cliente', text: 'diez noventa y siete cuatro cero tres siete cuatro' },
              { character: 'Agente', text: 'listo déjame, esperame un minutico mas y ya vuelvo contigo' },
              { character: 'Agente', text: 'gracias por permanecer en espera' },
              { character: 'Cliente', text: 'si senor' },
              { character: 'Agente', text: 'mira tu al parecer solo tienes este usuario, una pregunta, eh esta informacion tu la sacaste de un caso, es decir te la indicaron en un caso?' },
              { character: 'Cliente', text: 'no, no, mis coordinadores me dijeron que ya debía tener clave' },
              { character: 'Agente', text: 'listo le vas a informar lo siguiente, les dices que tu llamaste a validar y te dijeron que verificando tu usuario aparece todo desactivado y revocado. Diles que no te hicieron correctamente la reactivación. Ellos pueden, diles que ellos puede mirar por autoservicio entidad para que confirmen t vera que si tienes todo desactivado, tu eres Angela Mercela Martin Cardenas, cierto?' },
              { character: 'Cliente', text: 'si senor' },
              { character: 'Agente', text: 'si, efectivamente tienes todo desactivado y revocado entonces ellos tienen que hacer la solicitud nuevamente por formato para la reactivación de tu usuario, listo?' },
              { character: 'Cliente', text: 'okey listo' },
              { character: 'Agente', text: 'listo, este es un caso informativo igualmente para que lo tengas en cuenta, permítame un momentico en linea ya vuelvo con usted' },
              { character: 'Agente', text: 'gracias por tu amable tiempo en espera, listo, te confirmo Angela el record informativo es cincuenta y siete noventa doce' },
              { character: 'Cliente', text: 'okey' },
              { character: 'Agente', text: 'aparece _ informativo de la llamada' },
              { character: 'Cliente', text: 'si senor' },
              { character: 'Agente', text: 'para calificación de satisfacción gracias por comunicarse con Maiti ' },
              { character: 'Cliente', text: 'graciasAgente  Buen dia mi nombre es David Riveros con quien tengo el gusto de hablar' },
              { character: 'Cliente', text: 'senor David le habla Silvia Perez de Barranquilla, como me le va' },
              { character: 'Agente', text: ' muy bien senora Silvia y usted' },
              { character: 'Cliente', text: 'bien gracias a dios. Yo tengo una RQ con el numero cincuenta y siete seis dos treinta y siete, es la creación de usuario de tres usuario de cimax, pero no es la primera vez que lo envio, lo he enviado en varias ocasiones y siempre me sale, son tres usuarios, uno bueno y uno malo, y ya estoy cansada ya, a ver en que me pueden colaborar' },
              { character: 'Agente', text: ' Listo una consulta, este tambien son tres usuarios y paso lo mismo, si?' },
              { character: 'Cliente', text: 'claro, son los mismos, nada mas una sirve y las otras dos no, tengo que estar mandando formato de veintidós a ventidos yo ya estoy cansada' },
              { character: 'Agente', text: ' y no genero una queja por ese motiva senora Silvia' },
              { character: 'Cliente', text: 'lo que pasa es que tuve que llamarlo a usted porque yo ya no se que hacer y eso lo necesitan urgente acá ' },
              { character: 'Agente', text: ' indiqueme por favor su usuario de red' },
              { character: 'Cliente', text: 'yb1603' },
              { character: 'Agente', text: ' yb1603' },
              { character: 'Cliente', text: 'muy si señor' },
              { character: 'Agente', text: ' permitame le indico el requerimiento y regreso con usted' },
              { character: 'Cliente', text: 'gracias' },
              { character: 'Agente', text: 'con gusto' },
              { character: 'Agente', text: ' gracias por su amable espera en linea senora Silvia' },
              { character: 'Cliente', text: 'si senor, dígame' },
              { character: 'Agente', text: ' cual de los usuarios es el que si funciona y el que no' },
              { character: 'Cliente', text: 'el primero, si con geraldin no y Wilmer tampoco. El primero únicamente el de Yarilis' },
              { character: 'Agente', text: ' que error le genero los otros dos' },
              { character: 'Cliente', text: 'no se queda ahí en blanco, no me da la opción, se queda en blanco, a penas ingreso la clave no me dice nada' },
              { character: 'Agente', text: ' no sale ni error ni nada se queda ahí cargando' },
              { character: 'Cliente', text: 'ya le digo, vuelvo a ingresar' },
              { character: 'Agente', text: ' por favor que va a ingresar en este momento, un paso a paso del proceso ' },
              { character: 'Cliente', text: 'yo prefiero, no porque eso no, eso me sale enseguida, le comento eso no hay que enviar pantallazos porque lo que me sale, no me sale ningunb pantallazo simplemente ingreso la clave y se desaparece, no se, no hay nada, no sale ningún pantallazo' },
              { character: 'Agente', text: ' lo que pasa es que para generar la queja tenemos que enviar una evidencia de lo que ocurre para ingresar, si no no le puedo generar' },
              { character: 'Cliente', text: 'no, pero es que sale en blanco, coloque así que eso es lo que me sale, a mi no me dice que esta mal ' },
              { character: 'Agente', text: ' en este caso si no puede generar la evidencia necesitaría que usted lo pusiera desde el maiti senora Silvia, porque a nosotros nos piden la evidencia, en este caso usted puede ingresar a maiti ' },
              { character: 'Cliente', text: 'no, yo no hago la queja, siempre me han ayudado allí. De todas maneras no importa yo mando otra vez el E veintidós no se preocupe ' },
              { character: 'Agente', text: ' De acuerdo senora Silviaç' },
              { character: 'Cliente', text: 'cuando yo he llamado allá me arreglan las claves, no se porque ahora no, osea es que mire usted todo lo que he mandado usted se puede fijar allí donde esta, una creación y mire todos los inconvenientes que ha tenido, desde el dia tres. Entonces tranquilo cualguela la, yo lo mando nuevamente con paciencia ' },
              { character: 'Agente', text: ' Debe de tener en cuenta que…' },
              { character: 'Cliente', text: 'No sale nada, que pantallazo voy a mandar, escriba allí que en el momento de ingresar no sale nada en pantalla, no sirven las lcaves' },
              { character: 'Agente', text: ' es que si fuera que no sivieran las claves generaría un error y por eso…' },
              { character: 'Cliente', text: 'usted las puede revisar allá pars que vea que no, que no sale error' },
              { character: 'Agente', text: ' nosotros no tenemos acceso a la herramienta senora Silvia' },
              { character: 'Cliente', text: 'entiendo, bueno senor muchas gracias' },
              { character: 'Agente', text: ' por ese motivo no puedo yo generar el proceso de generación' },
              { character: 'Cliente', text: 'okey, bueno muchas gracias yo mando el formatito' },
              { character: 'Agente', text: ' de acuerdo, permítame le indico el numero con el que queda generado la consulta. Le confirmo su numero de celular es el tres catorce ocho cincuenta y uno diez setanta y nueve, correcto?' },
              { character: 'Cliente', text: 'muy bien, así es' },
              { character: 'Agente', text: ' y la extensión es la diecinueve seis cuarenta' },
              { character: 'Cliente', text: 'si senor' },
              { character: 'Agente', text: ' permitame le indico el numero con el que queda generado el informativo es el R de Q cincuenta y ocho veintiocho cuenta y siete. Me autoriza generar cierre de este informative' },
              { character: 'Cliente', text: 'bien pueda' },
              { character: 'Agente', text: ' de acuerdo senora Silvia, le dejo comunicada con la calificación del servicio que le brinde, gracias por comuncarse a maiti que tenga buen día, hasta luego' }
            ]
          },
          audioFrequence: [],
          wordcloud: [['buen', 1], ['dia', 1], ['Mi', 1], ['nombre', 1], ['Sebastian', 1], ['Lopez', 1], ['con', 1], ['quien', 1], ['te', 1], ['gusta', 1], ['hablar', 1], ['horas', 1], ['detenido', 1], ['dirigente', 1], ['acabar', 1], ['con', 1], ['vida', 1], ['tocar', 1], ['no', 1], ['la', 1], ['que', 1], ['te', 1], ['toco', 1], ['la', 1], ['hora', 1], ['y', 1], ['media', 1], ['para', 1], ['los', 1], ['y', 1], ['la', 1], ['buena', 1], ['tajada', 1], ['por', 1], ['medio', 1], ['de', 1], ['los', 1], ['que', 1], ['tiene', 1], ['ahora', 1], ['y', 1], ['mucho', 1], ['trabajo', 1], ['y', 1], ['familia', 1], ['que', 1], ['le', 1], ['suban', 1], ['y', 1], ['bajen', 1], ['los', 1], ['recuerdos', 1], ['y', 1], ['tuvimos', 1], ['una', 1], ['politica', 1], ['ya', 1], ['mismo', 1], ['y', 1], ['y', 1], ['ya', 1], ['que', 1], ['sabes', 1], ['de', 1], ['ano', 1], ['para', 1], ['igual', 1], ['yo', 1], ['que', 1], ['hizo', 1], ['la', 1], ['solicitud', 1], ['fuera', 1], ['por', 1], ['el', 1], ['mallorquin', 1], ['pero', 1], ['a', 1], ['el', 1], ['le', 1], ['llego', 1], ['un', 1], ['correo', 1], ['Pues', 1], ['el', 1], ['coordinador', 1], ['que', 1], ['pero', 1], ['quiza', 1], ['la', 1], ['solicitud', 1], ['directamente', 1], ['le', 1], ['respondieron', 1], ['la', 1], ['siguiente', 1], ['que', 1], ['la', 1], ['solicitud', 1], ['de', 1], ['generar', 1], ['mediante', 1], ['la', 1], ['herramienta', 1], ['de', 1], ['automatizacion', 1], ['tal', 1], ['fue', 1], ['le', 1], ['dieron', 1], ['un', 1], ['nino', 1], ['y', 1], ['el', 1], ['otro', 1], ['libreta', 1], ['Y', 1], ['supuestamente', 1], ['para', 1], ['que', 1], ['lo', 1], ['mismo', 1], ['llegaron', 1], ['con', 1], ['velar', 1], ['y', 1], ['demas', 1], ['Si', 1], ['parece', 1], ['como', 1], ['destituirle', 1], ['sobre', 1], ['el', 1], ['Oratorio', 1], ['ya', 1], ['sea', 1], ['tan', 1], ['dirigencial', 1], ['del', 1], ['formulario', 1], ['en', 1], ['el', 1], ['tema', 1], ['como', 1], ['obligatorio', 1], ['porque', 1], ['tiene', 1], ['alli', 1], ['la', 1], ['perdida', 1], ['del', 1], ['color', 1], ['No', 1], ['y', 1], ['quiero', 1], ['y', 1], ['no', 1], ['te', 1], ['la', 1], ['empresaria', 1], ['en', 1], ['mi', 1], ['La', 1], ['fabrica', 1], ['Exactamente', 1], ['los', 1], ['datos', 1], ['actualizados', 1], ['de', 1], ['eso', 1], ['es', 1], ['verdad', 1], ['a', 1], ['  no', 1], ['sea', 1], ['el', 1], ['nombre', 1], ['de', 1], ['la', 1], ['empresa', 1], ['el', 1], ['NIF', 1], ['el', 1], ['permitir', 1], ['como', 1], ['tal', 1], ['Comunicado', 1], ['figura', 1], ['asimismo', 1], ['la', 1], ['candidata', 1], ['alguna', 1], ['vez', 1], ['pues', 1], ['como', 1], ['que', 1], ['tenia', 1], ['para', 1], ['lo', 1], ['que', 1], ['hace', 1], ['todavia', 1], ['vete', 1], ['al', 1], ['medio', 1], ['para', 1], ['conseguir', 1], ['todavia', 1], ['aqui', 1], ['No', 1], ['al', 1], ['estres', 1], ['Lo', 1], ['que', 1], ['va', 1], ['es', 1], ['que', 1], ['no', 1], ['No', 1], ['manejamos', 1], ['esa', 1], ['informacion', 1], ['y', 1], ['a', 1], ['ver', 1], ['si', 1], ['me', 1], ['dejas', 1], ['cayo', 1], ['Caigamos', 1], ['muy', 1], ['bien', 1], ['La', 1], ['misma', 1], ['pagina', 1], ['porque', 1], ['por', 1], ['lo', 1], ['que', 1], ['tengo', 1], ['entendido', 1], ['se', 1], ['postulaba', 1], ['ya', 1], ['todo', 1], ['que', 1], ['hace', 1], ['grande', 1], ['a', 1], ['Mosquera', 1], ['Telmex', 1], ['y', 1], ['con', 1], ['conciertos', 1], ['Y', 1], ['ahora', 1], ['sabemos', 1], ['que', 1], ['hubo', 1], ['una', 1], ['mayoria', 1], ['solamente', 1], ['se', 1], ['conocen', 1], ['gente', 1], ['No', 1], ['se', 1], ['si', 1], ['yo', 1], ['yo', 1], ['creo', 1], ['como', 1], ['claro', 1], ['esa', 1], ['actitud', 1], ['Que', 1], ['tal', 1], [' Tiene', 1], ['poca', 1], ['comunes', 1], ['del', 1], ['cartel', 1], ['de', 1], ['Colombia', 1], ['libre', 1], ['la', 1], ['calle', 1], ['Lo', 1], ['tengo', 1], ['Es', 1], ['Telmex', 1], ['Colombia', 1], ['sea', 1], ['Y', 1], ['el', 1], ['mismo', 1], ['tema', 1], ['Alguien', 1], ['que', 1], ['me', 1], ['pueda', 1], ['poner', 1], ['eso', 1], ['de', 1], ['cuatro', 1], ['hojas', 1], ['de', 1], ['la', 1], ['riqueza', 1], ['de', 1], ['porque', 1], ['no', 1], ['no', 1], ['no', 1], ['no', 1], ['no', 1], ['Tranquilo', 1], ['No', 1], ['no', 1], ['no', 1], ['no', 1], ['Eso', 1], ['Si', 1], ['Todo', 1], ['Pues', 1], ['seguro', 1], ['que', 1], ['ellos', 1], ['por', 1], ['eso', 1], ['no', 1], ['no', 1], ['molestan', 1], ['realmente', 1], ['a', 1], ['ponerlo', 1], ['asi', 1], ['Esa', 1], ['yo', 1], ['tengo', 1], ['por', 1], ['ti', 1], ['Bueno', 1], ['ya', 1], ['veremos', 1], ['si', 1], ['preguntamos', 1], ['a', 1], ['decidir', 1], ['si', 1], ['no', 1], ['no', 1], ['no', 1], ['es', 1], ['que', 1], ['la', 1], ['gente', 1], ['vaya', 1], ['Bueno', 1], ['vale', 1], ['pero', 1], ['ya', 1], ['se', 1], ['ha', 1], ['informado', 1], ['como', 1], ['vamos', 1], ['venga', 1], ['ya', 1], ['No', 1], ['no', 1], ['la', 1], ['manejan', 1], ['ustedes', 1], ['directamente', 1], ['No', 1], ['esa', 1], ['no', 1], ['la', 1], ['manejamos', 1], ['Pero', 1], ['de', 1], ['se', 1], ['que', 1], ['por', 1], ['eso', 1], ['no', 1], ['molestan', 1], ['realmente', 1], ['Cual', 1], ['es', 1], ['la', 1], ['lista', 1], ['que', 1], ['analiza', 1], ['Tra', 1], ['para', 1], ['nada', 1], ['Pues', 1], ['por', 1], ['ahora', 1], ['ya', 1], ['no', 1], ['vale', 1], ['Se', 1], ['de', 1], ['la', 1], ['calificacion', 1], ['de', 1], ['servicio', 1], ['y', 1], ['que', 1], ['era', 1], ['el', 1], ['esfuerzo', 1], ['en', 1], ['Cartama', 1], ['y', 1], ['que', 1], ['termina', 1]],

          sentimental: [
            { name: 'Positivo', count: 0 },
            { name: 'Neutral', count: 1.0 },
            { name: 'Negativo', count: 0 }
          ],
          dominance: {
            advisor: 0.44,
            client: 0.56
          }
        })
      })
  })
}

speech.getProjectNlpFreqIntention = (companyId, appId, { id }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      /*
      headers: {
      'Authorization': 'Bearer ' + token
      },
      */
      url: `${UrlBase}company/${companyId}/app/${appId}/project/${id}/nlp/freq/intention`
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(() => { // error => {
        // let message = error.response
        // if (!message) return reject(new Error(error.message))
        // else return reject(new Error(message.data.error))
        let nlpFreqIntention = []
        let count = 0
        if (id === '1') {
          nlpFreqIntention = [
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'mi nombre es', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'mi nombre', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'nombre es', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Justificacion espera', Subcategoria: 'justificacion: si', FRECUENCIA: 'requierimiento', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: general', FRECUENCIA: 'nombre de usuario', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: general', FRECUENCIA: 'usuario de red', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'espera: solicita', FRECUENCIA: 'regaleme un', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'espera: solicita', FRECUENCIA: 'un momento', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'espera: solicita', FRECUENCIA: 'espera en linea', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'espera: agradece', FRECUENCIA: 'gracias por su', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'espera: agradece', FRECUENCIA: 'agradezco', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio', FRECUENCIA: 'numero de radicado', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio', FRECUENCIA: 'radicado', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio', FRECUENCIA: 'de radicado', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio', FRECUENCIA: 'registro llamada', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio', FRECUENCIA: 'registro de la', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio', FRECUENCIA: 'el numero de radicado', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio', FRECUENCIA: 'radicado es', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio', FRECUENCIA: 'el numero de ', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'autorizacion cierre', FRECUENCIA: 'autoriza', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'autorizacion cierre', FRECUENCIA: 'cierre servicio', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'autorizacion cierre', FRECUENCIA: 'cierre de servicio', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa', FRECUENCIA: 'gracias por comunicarse', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa', FRECUENCIA: 'comunicarse', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa', FRECUENCIA: 'comunicarse con', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia encuesta', FRECUENCIA: 'transfiero', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia encuesta', FRECUENCIA: 'transfiero a la encuesta', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia encuesta', FRECUENCIA: 'transfiero encuesta', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: general', FRECUENCIA: 'con quien', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: general', FRECUENCIA: 'el gusto de hablar', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: general', FRECUENCIA: 'tengo el gusto', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'cordialidad', FRECUENCIA: 'colaborar', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: general', FRECUENCIA: 'llama de', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: general', FRECUENCIA: 'numero de contacto', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: general', FRECUENCIA: 'evidencia', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'justificacion: si', FRECUENCIA: ' validando', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'justificacion: si', FRECUENCIA: ' validando internamente', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'justificacion: si', FRECUENCIA: ' que pena', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'justificacion: si', FRECUENCIA: ' demora', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'justificacion: si', FRECUENCIA: ' voy a hacer', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia encuesta', FRECUENCIA: 'enviar a', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'autorizacion cierre', FRECUENCIA: 'cierre de esta llamada', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'autorizacion cierre', FRECUENCIA: 'cierre de la llamada', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'autorizacion cierre', FRECUENCIA: 'cierre de', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'habla con', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'cordialidad', FRECUENCIA: 'buenos dias', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'cordialidad', FRECUENCIA: 'buenas tardes', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'cordialidad', FRECUENCIA: 'buenas noches', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia', FRECUENCIA: 'encuesta calificacion', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia', FRECUENCIA: 'encuesta calificacion de el servicio', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia', FRECUENCIA: 'encuesta califiacacion del servicio', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa', FRECUENCIA: 'gracias por llamar a', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa', FRECUENCIA: 'llamar a', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa', FRECUENCIA: 'por comunicarse', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa', FRECUENCIA: 'por comunicarse a', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'protocolo de abandono', FRECUENCIA: 'retornar', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'protocolo de abandono', FRECUENCIA: 'retornar a la llamada', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'protocolo de abandono', FRECUENCIA: 'retornar la llamada', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'protocolo de abandono', FRECUENCIA: 'retorno', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'espera: solicita', FRECUENCIA: 'verificar con', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: cumpleaños', FRECUENCIA: 'cumpleaños', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa', FRECUENCIA: 'mighty', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea', Subcategoria: 'espera: agradece', FRECUENCIA: 'espera', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia', FRECUENCIA: 'encuesta de servicio', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia', FRECUENCIA: 'encuesta del servicio', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia', FRECUENCIA: 'encuesta servicio prestado', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia', FRECUENCIA: 'encuesta servicio ', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'transferencia', FRECUENCIA: 'encuesta satisfaccion ', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa', FRECUENCIA: 'gracias por', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'giovanny', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'gustavo', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'gerald', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'carolina', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'diana', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'yasmin', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'wilson', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'camilo', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'catherine', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'caterine', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'miguel', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'milton', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'bryan', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'juan ', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'jhony', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'pablo', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo', FRECUENCIA: 'nicolas', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: general', FRECUENCIA: 'usuario de red', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea espera: solicita permite', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea espera: solicita me permite', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea espera: solicita permite un', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio corresponde al', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio corresponde', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa comunicarse', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa Maite', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa calificar', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa comunicarte ', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'nombre mesa cierre', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: cumpleaños cumpleanos', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo Mi nombre', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion inicio de llamada', Subcategoria: 'guion inicio: ID completo nombre', fRQ: '2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio R eco', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio RQ', fRQ: '1%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio erre q', fRQ: '3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Guion fin de llamada', Subcategoria: 'numero de servicio incidencia ', fRQ: '0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Espera en linea espera: solicita momentos', fRQ: '0%' }
          ]
          count = 100
        } else if (id === '2') {
          nlpFreqIntention = [
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'CONTRATO VENTAS', Subcategoria: 'verificar su identidad', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad', Subcategoria: 'ha sido confirmad', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad', Subcategoria: 'fuente toda la información', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad', Subcategoria: 'validar nombre', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'validar nombre', Subcategoria: 'ratamiento de sus datos', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'validar nombre', Subcategoria: 'adquirir el equipo', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'adquirir el equipo', Subcategoria: 'primera factura', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'primera factura', Subcategoria: 'pagar', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'adquirir el equipo', Subcategoria: 'entrega del equipo', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad', Subcategoria: 'retracto', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'VENTAS SERVICIOS', Subcategoria: 'verificar su identidad,', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad,', Subcategoria: 'grabación del contrato ', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad,', Subcategoria: 'fuente de información', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'fuente de información', Subcategoria: 'tratamiento de datos', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad,', Subcategoria: 'número de celular', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad,', Subcategoria: 'correo electrónico', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad,', Subcategoria: 'nacimiento', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'verificar su identidad,', Subcategoria: 'servicios contratados', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'servicios contratados', Subcategoria: 'nombre plan', FRECUENCIA: '4', fRQ: '5.0%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'servicios contratados', Subcategoria: 'costo fijo', FRECUENCIA: '4', fRQ: '5.0%' }
          ]
          count = 20
        } else if (id === '3' || id === '4' || id === '5' || id === '6' || id === '7') {
          nlpFreqIntention = [
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'Saludo', Subcategoria: 'presentacion', FRECUENCIA: '5', fRQ: '3.3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'presentacion', Subcategoria: 'nombre agente', FRECUENCIA: '7', fRQ: '4.6%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'nombre agente', Subcategoria: 'en el codensa', FRECUENCIA: '9', fRQ: '5.9%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'confirmar nombre cliente', Subcategoria: 'tiene contrarto de seguros?', FRECUENCIA: '5', fRQ: '3.3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'tiene contrarto de seguros?', Subcategoria: 'SI', FRECUENCIA: '7', fRQ: '4.6%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'SI', Subcategoria: 'con quien?', FRECUENCIA: '10', fRQ: '6.5%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'con quien?', Subcategoria: 'tipo de seguro', FRECUENCIA: '7', fRQ: '4.6%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'tipo de seguro', Subcategoria: 'vida', FRECUENCIA: '9', fRQ: '5.9%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'tipo de seguro', Subcategoria: 'funerario', FRECUENCIA: '5', fRQ: '3.3%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'tipo de seguro', Subcategoria: 'famila', FRECUENCIA: '7', fRQ: '4.6%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'vida', Subcategoria: 'esta interesado', FRECUENCIA: '10', fRQ: '6.5%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'funerario', Subcategoria: 'esta interesado', FRECUENCIA: '7', fRQ: '4.6%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'famila', Subcategoria: 'esta interesado', FRECUENCIA: '7', fRQ: '4.6%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'esta interesado', Subcategoria: 'si', FRECUENCIA: '8', fRQ: '5.2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'esta interesado', Subcategoria: 'no', FRECUENCIA: '7', fRQ: '4.6%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'NO', Subcategoria: 'oferta', FRECUENCIA: '8', fRQ: '5.2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'oferta', Subcategoria: 'vida', FRECUENCIA: '8', fRQ: '5.2%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'oferta', Subcategoria: 'funerario', FRECUENCIA: '9', fRQ: '5.9%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'oferta', Subcategoria: 'famila', FRECUENCIA: '6', fRQ: '3.9%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'esta interesado', Subcategoria: 'si', FRECUENCIA: '6', fRQ: '3.9%' },
            { 'INTENCIONALIDAD COMUNICATIVA': 'Neutral', TIPOLOGiA: 'esta interesado', Subcategoria: 'no', FRECUENCIA: '6', fRQ: '3.9%' }
          ]
          count = 21
        }

        resolve({
          freqIntention: { // TODO move this to a database or something better
            rows: nlpFreqIntention,
            count
          }
        })
      })
  })
}

speech.getProjectNlpNetwork = (companyId, appId, { id }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      /*
      headers: {
      'Authorization': 'Bearer ' + token
      },
      */
      url: `${UrlBase}company/${companyId}/app/${appId}/project/${id}/nlp/network`
    }
    axios(request)
      .then(response => {
        resolve(response.data)
      })
      .catch(() => { // error => {
        // let message = error.response
        // if (!message) return reject(new Error(error.message))
        // else return reject(new Error(message.data.error))
        let network = {}
        if (id === '1') {
          network = {
            chart: {
              type: 'networkgraph',
              height: '100%'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              networkgraph: {
                keys: ['from', 'to'],
                layoutAlgorithm: {
                  enableSimulation: true,
                  friction: -0.9
                }
              }
            },
            series: [
              {
                dataLabels: {
                  enabled: true,
                  linkFormat: ''
                },
                data: [
                  ['Espera en linea', 'espera: agradece'],
                  ['Espera en linea', 'espera: solicita'],
                  ['Espera en linea', 'justificacion: si '],
                  ['Guion fin de llamada', 'autorizacion cierre'],
                  ['Guion fin de llamada', 'nombre mesa'],
                  ['Guion fin de llamada', 'numero de servicio'],
                  ['Guion fin de llamada', 'protocolo de abandono'],
                  ['Guion fin de llamada', 'transferencia encuesta'],
                  ['Guion inicio de llamada', 'cordialidad'],
                  ['Guion inicio de llamada', 'guion inicio: cumpleaños'],
                  ['Guion inicio de llamada', 'guion inicio: general'],
                  ['Guion inicio de llamada', 'guion inicio: ID completo'],
                  ['Guion inicio de llamada', 'guion inicio: cumpleaños'],
                  ['Guion inicio de llamada', 'guion inicio: general'],
                  ['Guion inicio de llamada', 'guion inicio: ID completo'],
                  ['Justificacion espera', 'justificacion: si '],
                  ['autorizacion cierre', 'autoriza'],
                  ['autorizacion cierre', 'cierre de'],
                  ['autorizacion cierre', 'cierre de esta llamada'],
                  ['autorizacion cierre', 'cierre de la llamada'],
                  ['autorizacion cierre', 'cierre de servicio'],
                  ['autorizacion cierre', 'cierre servicio'],
                  ['cordialidad', 'buenas noches'],
                  ['cordialidad', 'buenas tardes'],
                  ['cordialidad', 'buenos dias'],
                  ['cordialidad', 'colaborar'],
                  ['espera: agradece', 'agradezco'],
                  ['espera: agradece', 'espera'],
                  ['espera: agradece', 'gracias por su'],
                  ['espera: solicita', 'espera en linea'],
                  ['espera: solicita', 'me permite'],
                  ['espera: solicita', 'momentos'],
                  ['espera: solicita', 'permite'],
                  ['espera: solicita', 'permite un'],
                  ['espera: solicita', 'regaleme un'],
                  ['espera: solicita', 'un momento'],
                  ['espera: solicita', 'verificar con'],
                  ['guion inicio: cumpleaños', 'cumpleanos'],
                  ['guion inicio: cumpleaños', 'cumpleaños'],
                  ['guion inicio: general', 'con quien'],
                  ['guion inicio: general', 'el gusto de hablar'],
                  ['guion inicio: general', 'evidencia'],
                  ['guion inicio: general', 'llama de'],
                  ['guion inicio: general', 'nombre de usuario'],
                  ['guion inicio: general', 'numero de contacto'],
                  ['guion inicio: general', 'tengo el gusto'],
                  ['guion inicio: general', 'usuario de red'],
                  ['guion inicio: ID completo', 'bryan'],
                  ['guion inicio: ID completo', 'camilo'],
                  ['guion inicio: ID completo', 'carolina'],
                  ['guion inicio: ID completo', 'caterine'],
                  ['guion inicio: ID completo', 'catherine'],
                  ['guion inicio: ID completo', 'diana'],
                  ['guion inicio: ID completo', 'gerald'],
                  ['guion inicio: ID completo', 'giovanny'],
                  ['guion inicio: ID completo', 'gustavo'],
                  ['guion inicio: ID completo', 'habla con'],
                  ['guion inicio: ID completo', 'jhony'],
                  ['guion inicio: ID completo', 'juan '],
                  ['guion inicio: ID completo', 'mi nombre'],
                  ['guion inicio: ID completo', 'mi nombre es'],
                  ['guion inicio: ID completo', 'miguel'],
                  ['guion inicio: ID completo', 'milton'],
                  ['guion inicio: ID completo', 'nicolas'],
                  ['guion inicio: ID completo', 'nombre'],
                  ['guion inicio: ID completo', 'nombre es'],
                  ['guion inicio: ID completo', 'pablo'],
                  ['guion inicio: ID completo', 'wilson'],
                  ['guion inicio: ID completo', 'yasmin'],
                  ['justificacion: si ', 'demora'],
                  ['justificacion: si ', 'que pena'],
                  ['justificacion: si ', 'requierimiento'],
                  ['justificacion: si ', 'validando'],
                  ['justificacion: si ', 'validando internamente'],
                  ['justificacion: si ', 'voy a hacer'],
                  ['nombre mesa', 'calificar'],
                  ['nombre mesa', 'cierre'],
                  ['nombre mesa', 'comunicarse'],
                  ['nombre mesa', 'comunicarse con'],
                  ['nombre mesa', 'comunicarte '],
                  ['nombre mesa', 'gracias por'],
                  ['nombre mesa', 'gracias por comunicarse'],
                  ['nombre mesa', 'gracias por llamar a'],
                  ['nombre mesa', 'llamar a'],
                  ['nombre mesa', 'Maite'],
                  ['nombre mesa', 'mighty'],
                  ['nombre mesa', 'por comunicarse'],
                  ['nombre mesa', 'por comunicarse a'],
                  ['numero de servicio', 'corresponde'],
                  ['numero de servicio', 'corresponde al'],
                  ['numero de servicio', 'de radicado'],
                  ['numero de servicio', 'el numero de '],
                  ['numero de servicio', 'el numero de radicado'],
                  ['numero de servicio', 'erre q'],
                  ['numero de servicio', 'incidencia '],
                  ['numero de servicio', 'numero de radicado'],
                  ['numero de servicio', 'R eco'],
                  ['numero de servicio', 'radicado'],
                  ['numero de servicio', 'radicado es'],
                  ['numero de servicio', 'registro de la'],
                  ['numero de servicio', 'registro llamada'],
                  ['numero de servicio', 'RQ'],
                  ['protocolo de abandono', 'retornar'],
                  ['protocolo de abandono', 'retornar a la llamada'],
                  ['protocolo de abandono', 'retornar la llamada'],
                  ['protocolo de abandono', 'retorno'],
                  ['transferencia encuesta', 'califiacacion del servicio'],
                  ['transferencia encuesta', 'calificacion'],
                  ['transferencia encuesta', 'calificacion de el servicio'],
                  ['transferencia encuesta', 'de servicio'],
                  ['transferencia encuesta', 'del servicio'],
                  ['transferencia encuesta', 'enviar a'],
                  ['transferencia encuesta', 'satisfaccion '],
                  ['transferencia encuesta', 'servicio '],
                  ['transferencia encuesta', 'servicio prestado'],
                  ['transferencia encuesta', 'transfiero'],
                  ['transferencia encuesta', 'transfiero a la encuesta'],
                  ['transferencia encuesta', 'transfiero encuesta']
                ]
              }
            ]
          }
        } else if (id === '2') {
          network = {
            chart: {
              type: 'networkgraph',
              height: '100%'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              networkgraph: {
                keys: ['from', 'to'],
                layoutAlgorithm: {
                  enableSimulation: true,
                  friction: -0.9
                }
              }
            },
            series: [
              {
                dataLabels: {
                  enabled: true,
                  linkFormat: ''
                },
                data: [
                  ['CONTRATO VENTAS', 'verificar su identidad'],
                  ['verificar su identidad', 'ha sido confirmad'],
                  ['verificar su identidad', 'fuente toda la información'],
                  ['verificar su identidad', 'validar nombre'],
                  ['validar nombre', 'ratamiento de sus datos'],
                  ['validar nombre', 'adquirir el equipo'],
                  ['adquirir el equipo', 'primera factura'],
                  ['primera factura', 'pagar'],
                  ['adquirir el equipo', 'entrega del equipo'],
                  ['verificar su identidad', ' retracto'],
                  ['VENTAS SERVICIOS', 'verificar su identidad,'],
                  ['verificar su identidad,', 'grabación del contrato '],
                  ['verificar su identidad,', 'fuente de información'],
                  ['fuente de información', 'tratamiento de datos'],
                  ['verificar su identidad,', 'número de celular'],
                  ['verificar su identidad,', 'correo electrónico'],
                  ['verificar su identidad,', 'nacimiento'],
                  ['verificar su identidad,', 'servicios contratados'],
                  ['servicios contratados', 'nombre plan'],
                  ['servicios contratados', 'costo fijo']
                ]
              }
            ]
          }
        } else if (id === '3') {
          network = {
            chart: {
              type: 'networkgraph',
              height: '100%'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              networkgraph: {
                keys: ['from', 'to'],
                layoutAlgorithm: {
                  enableSimulation: true,
                  friction: -0.9
                }
              }
            },
            series: [
              {
                dataLabels: {
                  enabled: true,
                  linkFormat: ''
                },
                data: [
                  ['SALUDO', 'presentacion'],
                  ['presentacion', 'nombre agente'],
                  ['nombre agente', 'enel codensa'],
                  ['enel codensa', 'confirmar nombre cliente'],
                  ['confirmar nombre cliente', 'tiene contrarto de seguros?'],
                  ['tiene contrarto de seguros?', 'SI'],
                  ['SI', 'con quien?'],
                  ['con quien?', 'tipo de seguro'],
                  ['tipo de seguro', 'vida'],
                  ['tipo de seguro', 'funerario'],
                  ['tipo de seguro', 'famila'],
                  ['vida', 'esta interesado'],
                  ['funerario', 'esta interesado'],
                  ['famila', 'esta interesado'],
                  ['esta interesado', 'si'],
                  ['esta interesado', 'no'],
                  ['NO', 'oferta'],
                  ['oferta', 'vida'],
                  ['oferta', 'funerario'],
                  ['oferta', 'famila'],
                  ['esta interesado', 'si'],
                  ['esta interesado', 'no']
                ]
              }
            ]
          }
        } else if (id === '4' || id === '5' || id === '6' || id === '7') {
          network = {
            chart: {
              type: 'networkgraph',
              height: '100%'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              networkgraph: {
                keys: ['from', 'to'],
                layoutAlgorithm: {
                  enableSimulation: true,
                  friction: -0.9
                }
              }
            },
            series: [
              {
                dataLabels: {
                  enabled: true,
                  linkFormat: ''
                },
                data: [
                  ['generico', 'finalizamos la redencion '],
                  ['generico', 'redimir unos puntos'],
                  ['generico', 'voy a reclamar'],
                  ['inconformidad en el proceso de entrega', 'demoran tanto'],
                  ['inconformidad en el proceso de entrega', 'para preguntarle por unos pedidos'],
                  ['informacion general sobre productos', 'duda sobre un producto'],
                  ['informacion general sobre productos', 'explicame eso'],
                  ['informacion general sobre productos', 'la informacion no la tiene el tarro'],
                  ['informacion general sobre productos', 'la verdad no se'],
                  ['informacion general sobre productos', 'me corcho'],
                  ['informacion general sobre productos', 'me esta preguntando'],
                  ['informacion general sobre productos', 'necesitamos una pintura'],
                  ['informacion general sobre productos', 'necesito una asesoria'],
                  ['informacion general sobre productos', 'quien me puede ayudar'],
                  ['informacion general sobre productos', 'siempre he comprado'],
                  ['informacion general sobre productos', 'tengo un cliente'],
                  ['informacion proveedores', 'aliados '],
                  ['informacion proveedores', 'busco en internet'],
                  ['informacion proveedores', 'consultar el telefono'],
                  ['informacion proveedores', 'el precio puede variar'],
                  ['informacion proveedores', 'el precio sugerido '],
                  ['informacion proveedores', 'es directamente con'],
                  ['informacion proveedores', 'he estado buscando en todas partes'],
                  ['informacion proveedores', 'lo solicitaron'],
                  ['informacion proveedores', 'me averigua'],
                  ['informacion proveedores', 'no tengo el telefono'],
                  ['informacion proveedores', 'pintacasa'],
                  ['informacion proveedores', 'proveedores'],
                  ['informacion proveedores', 'proveedores que tienen'],
                  ['informacion proveedores', 'puntos de venta'],
                  ['informacion proveedores', 'tengo tambien en'],
                  ['informacion proveedores', 'tiene el telefono'],
                  ['informacion proveedores', 'varios proveedores'],
                  ['informacion proveedores', 'y ellos manejan el mismo precio'],
                  ['informacion proveedores', 'ya le digo donde queda'],
                  ['informacion sobre inventarios', 'agota el inventario'],
                  ['informacion sobre inventarios', 'agotado'],
                  ['informacion sobre inventarios', 'disponibilidad del producto'],
                  ['informacion sobre inventarios', 'en este momento tenemos'],
                  ['informacion sobre inventarios', 'hay disponible '],
                  ['informacion sobre inventarios', 'la diponibilidad no la manejo'],
                  ['informacion sobre inventarios', 'le podriamos mandar'],
                  ['informacion sobre inventarios', 'los hay'],
                  ['informacion sobre inventarios', 'me esta solicitando'],
                  ['informacion sobre inventarios', 'necesito el precio'],
                  ['informacion sobre inventarios', 'no disponible'],
                  ['informacion sobre inventarios', 'no esta disponible '],
                  ['informacion sobre inventarios', 'no hay disponibilidad'],
                  ['informacion sobre inventarios', 'no manejamos '],
                  ['informacion sobre inventarios', 'no tenemos'],
                  ['informacion sobre inventarios', 'no tengo ninguno'],
                  ['informacion sobre inventarios', 'si tenemos'],
                  ['informacion sobre inventarios', 'tan pronto tengamos'],
                  ['informacion sobre inventarios', 'tiene un precio '],
                  ['pedidos', 'el inventario '],
                  ['pedidos', 'el pedido'],
                  ['pedidos', 'ingresar unos pedidos'],
                  ['pedidos', 'la orden de compra'],
                  ['pedidos', 'orden'],
                  ['pedidos', 'orden de compra'],
                  ['pedidos', 'que otro producto'],
                  ['pedidos', 'quedamos sujetos'],
                  ['pedidos', 'toma pedido'],
                  ['comercial/operativa', 'cordialidad'],
                  ['cordialidad', 'claro que si'],
                  ['cordialidad', 'comprendo'],
                  ['cordialidad', 'con todo gusto'],
                  ['cordialidad', 'entiendo'],
                  ['cordialidad', 'muy amable'],
                  ['cordialidad', 'por favor'],
                  ['cordialidad', 'si claro'],
                  ['cordialidad', 'te agradezco mucho'],
                  ['espera en linea', 'esperame un segundo'],
                  ['espera en linea', 'gracias por su espera'],
                  ['espera en linea', 'gracias por su permanencia en linea'],
                  ['espera en linea', 'permitame un momento'],
                  ['espera en linea', 'un momento'],
                  ['espera en linea', 'un momento yo reviso'],
                  ['inconformidad en el proceso de entrega', 'cliente que ya me pago'],
                  ['inconformidad en el proceso de entrega', 'hace rato'],
                  ['inconformidad en el proceso de entrega', 'lo pedimos hace rato'],
                  ['inconformidad en el proceso de entrega', 'perdimos hace rato'],
                  ['inconformidad en el proceso de entrega', 'poner la cara'],
                  ['protocolo: inicio ', 'con quien tengo el gusto'],
                  ['protocolo: inicio ', 'de tienda'],
                  ['protocolo: inicio ', 'habla con'],
                  ['protocolo: inicio ', 'le habla'],
                  ['protocolo: inicio ', 'Le saluda'],
                  ['protocolo: inicio ', 'un cliente'],
                  ['protocolo: inicio ', 'usted es vendedor'],
                  ['solucion y orientacion ', 'no dicen nada'],
                  ['solucion y orientacion ', 'nunca hay una solucion a la mano'],
                  ['solucion y orientacion ', 'poner la cara al cliente'],
                  ['operativa', 'inconformidad en el proceso de entrega'],
                  ['inconformidad en el proceso de entrega', 'dios mio'],
                  ['inconformidad en el proceso de entrega', 'diosmio'],
                  ['inconformidad en el proceso de entrega', 'el conductor'],
                  ['inconformidad en el proceso de entrega', 'le doy el numero del conductor'],
                  ['inconformidad en el proceso de entrega', 'los alcanza a entregar'],
                  ['inconformidad en el proceso de entrega', 'manana a primera hora'],
                  ['inconformidad en el proceso de entrega', 'no llegaron'],
                  ['inconformidad en el proceso de entrega', 'no tenemos fecha exacta'],
                  ['inconformidad en el proceso de entrega', 'pedimos hace rato'],
                  ['inconformidad en el proceso de entrega', 'que ya no alcanza hoy a llegar '],
                  ['inconformidad en el proceso de entrega', 'queda mal'],
                  ['inconformidad en el proceso de entrega', 'quedaron mal'],
                  ['inconformidad en el proceso de entrega', 'si los entrega hoy '],
                  ['inconformidad en el proceso de entrega', 'siempre quedan mal'],
                  ['inconformidad en el proceso de entrega', 'transportadora '],
                  ['inconformidad en el proceso de entrega', 'ya no alcanzo ']
                ]
              }
            ]
          }
        }

        resolve({ network })
      })
  })
}

export default speech
